import { render, staticRenderFns } from "./AdminAddMember.vue?vue&type=template&id=47ecb815&scoped=true&"
import script from "./AdminAddMember.vue?vue&type=script&lang=js&"
export * from "./AdminAddMember.vue?vue&type=script&lang=js&"
import style0 from "./AdminAddMember.vue?vue&type=style&index=0&id=47ecb815&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ecb815",
  null
  
)

export default component.exports